import { useEffect } from 'react'
import MotifMap from '../../components/MotifMap'
import MotifDetails from '../../components/MotifDetails'
import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { UIElement } from '../../types/UIElements'
import { useContextUI } from '../../contexts/UIContext'
import FirstVisitNotification from '../../components/FirstVisitNotification'

interface Props {
  canShowMotifMap?: boolean
}

const Home = ({ canShowMotifMap = true }: Props) => {
  const { areDetailsOpen, setDetailsOpen } = useContextMotifDetails()
  const { isAnimationShowing, elementsOpen, setElementsOpen } = useContextUI()

  useEffect(() => {
    if (elementsOpen.includes(UIElement.QRMODAL)) {
      setElementsOpen([UIElement.CONTROLS])
    }

    return () => {
      setDetailsOpen(false)
      setElementsOpen([UIElement.CONTROLS])
    }
  }, [])

  return (
    <>
      {isAnimationShowing ? (
        <FirstVisitNotification isAnimationShowing={isAnimationShowing} />
      ) : null}
      <MotifMap canDraw={canShowMotifMap} />
    </>
  )
}

export default Home
